import { render, staticRenderFns } from "./ArtistPageGeneralInformation.vue?vue&type=template&id=cbadaa9c&"
import script from "./ArtistPageGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./ArtistPageGeneralInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports